export default "__VITE_ASSET___0bArrpa__"